export default {
  PING_ENDPOINT: 'https://pastebin-phamdann.herokuapp.com/ping',
  GET_PASTE_ENDPOINT: 'https://pastebin-phamdann.herokuapp.com/v1/pastebin/%s',
  UPLOAD_PASTE_ENDPOINT: 'https://pastebin-phamdann.herokuapp.com/v1/pastebin/save',
}